(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class InspoInlineSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.clearButton = this.querySelector('[data-inspo-search-clear]');
      this.page = document.querySelector('[data-inspo-search-page]');
      this.grid = this.page?.querySelector('[data-inspo-search-grid]');
      this.cards = this.page ? [...this.page.querySelectorAll('[data-inspo-search-card]')] : [];
      this.queryLabel = this.page?.querySelector('[data-inspo-search-query]');
      this.status = this.page?.querySelector('[data-inspo-search-status]');
      this.empty = this.page?.querySelector('[data-inspo-search-empty]');
      this.viewAll = this.page?.querySelector('[data-inspo-view-all]');
      this.timer = null;
      this.latestQuery = '';
      this.input.value = '';

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        const query = this.input.value.trim();
        this.clearButton.hidden = !query;
        this.latestQuery = query;

        if (!query) {
          this.reset();
          return;
        }

        this.timer = window.setTimeout(() => this.search(query), 180);
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.clear();
        }
      });

      this.clearButton.addEventListener('click', () => this.clear());
      this.viewAll?.addEventListener('click', () => this.clear());
    }

    search(query) {
      if (!this.page || query !== this.latestQuery) return;
      const normalized = query.toLocaleLowerCase();
      let matches = 0;

      this.cards.forEach((card) => {
        const matchesQuery = card.dataset.search.includes(normalized);
        card.hidden = !matchesQuery;
        if (matchesQuery) matches += 1;
      });

      this.queryLabel.textContent = query;
      this.status.textContent = `${matches} ${matches === 1 ? 'scent' : 'scents'} found`;
      this.grid.hidden = matches === 0;
      this.empty.hidden = matches !== 0;
      this.page.hidden = false;
      document.documentElement.classList.add('inspo-search-mode');
    }

    reset() {
      window.clearTimeout(this.timer);
      this.latestQuery = '';
      this.page.hidden = true;
      this.cards.forEach((card) => { card.hidden = true; });
      this.grid.hidden = false;
      this.empty.hidden = true;
      this.status.textContent = '';
      document.documentElement.classList.remove('inspo-search-mode');
    }

    clear() {
      this.input.value = '';
      this.clearButton.hidden = true;
      this.reset();
      this.input.focus();
    }
  }

  if (!customElements.get('inspo-inline-search')) {
    customElements.define('inspo-inline-search', InspoInlineSearch);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
